import { DoneOutlined, InfoOutlined } from "@mui/icons-material";

export const SELLER_SORT_OPTIONS = [
  { value: "TONNAGE", label: "Tonnage Due" },
  { value: "ORD_PND", label: "Orders Pending" },
  { value: "OVERDUE_CNT", label: "Overdue Count" },
  { value: "FG_ADHERENCE", label: "FG Adherence" },
  { value: "MAX_AGE", label: "Max Ageing" },
];

export const DEFAULT_SELLER_SORT = {
  sortBy: "FG_ADHERENCE",
  sortDir: "ASC",
};

export const EMPTY_FG_TRACKING_DATA = {
  pagination: {},
  tabCounts: {},
  orders: [],
};

export const SORT_FIELD_MAP = {
  ageing: "aging",
  fgReadyBy: "fgDays",
};

export const DASHBOARD_TABLE_FILTERS = [
  {
    key: "fgduepend",
    label: "FG Due date pending",
    countKey: "fgduepend",
    icon: InfoOutlined,
    tooltip: "Active orders with at least one line pending FG update",
  },
  {
    key: "fgreadypend",
    label: "FG ready update pending",
    countKey: "fgreadypend",
    icon: DoneOutlined,
  },
];
